var HttpTransportType;
(function (HttpTransportType) {
    HttpTransportType["XHR"] = "xhr";
    HttpTransportType["Fetch"] = "fetch";
})(HttpTransportType || (HttpTransportType = {}));

export { HttpTransportType };
//# sourceMappingURL=types.js.map
